// export const firebaseConfig = {
//     apiKey: "AIzaSyDi97qoj_NRVDgpGYVkaJJlLAiTrYCnnkE",
//     authDomain: "meetyou-imageuploader.firebaseapp.com",
//     projectId: "meetyou-imageuploader",
//     storageBucket: "meetyou-imageuploader.appspot.com",
//     messagingSenderId: "219955809618",
//     appId: "1:219955809618:web:7179a62e59d9e96c04fe8b",
//     measurementId: "G-7JKGJ8731Q"
// };

export const firebaseConfig = {
  apiKey: "AIzaSyAQgXKUQuoqfcLxS8wr8caPGln1Z-zllNw",
  authDomain: "meet-you-87d01.firebaseapp.com",
  projectId: "meet-you-87d01",
  storageBucket: "meet-you-87d01.appspot.com",
  messagingSenderId: "29886699977",
  appId: "1:29886699977:web:44fe74c2f3f74faa5e7018"
}
